// @flow

export default class Organization {
  static orgAccess = Boolean(window.serverData._org);
}
